import React from 'react';
import { Button } from 'components/antd';
import { inject, observer } from 'mobx-react';
import { NewBookingsStore, RootStore } from 'AppClient/stores';

import classNames from 'classnames';
import styles from './styles.module.scss';
import { withAuthComponent } from 'components/PrivateRoute/PrivateRoute';
import { User } from 'oidc-client';
import { ThemeContext } from 'app-themes';

interface Props {
	user: User;
	message: string;
	noAnyDate?: boolean;
	newBookingsStore?: NewBookingsStore;
}

const NoBookingInfo: React.FC<Props> = props => {
	const handleOnNewBook = () => {
		props.newBookingsStore!.toggleModal(true);
	};
	const { noAnyDate = false, message, user } = props;
	return (
		<ThemeContext.Consumer>
			{(theme: string) => (
				<div
					className={classNames(styles.noBooking, {
						[styles[`noBooking-${theme}`]]: theme !== '',
					})}
				>
					<div className={styles.noBookingWrapper}>
						{noAnyDate && (
							<div className={classNames(styles.noBookingBox, styles.user)}>
								Hello {user.profile.given_name},
								<br />
								welcome to GroundScope
							</div>
						)}
						<div className={styles.noBookingBox}>
							<div className={styles.noBookingImg} />
							<div className={styles.noBookingNotify}>{message}</div>
						</div>
						{noAnyDate && (
							<div className={styles.noBookingBox}>
								<Button size="large" type="primary" onClick={handleOnNewBook}>
									New booking
								</Button>
							</div>
						)}
					</div>
				</div>
			)}
		</ThemeContext.Consumer>
	);
};

export default withAuthComponent(
	inject(({ newBookingsStore }: RootStore) => ({
		newBookingsStore,
	}))(observer(NoBookingInfo))
);
